export default __webpack_public_path__ + "static/media/pe2_2.baee9fac.jpg";